(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[499],{

/***/ 83518:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hizmetler",
      function () {
        return __webpack_require__(63579);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 58091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32852);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_common_BImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69327);
/* harmony import */ var components_common_TranslatedLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31468);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21395);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);





var OrganizationCard = function(param) {
    var title = param.title, description = param.description, imageUrl = param.imageUrl, slug = param.slug, className = param.className, _prioritizeImg = param.prioritizeImg, prioritizeImg = _prioritizeImg === void 0 ? false : _prioritizeImg;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("w-40 md:w-72", className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_TranslatedLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            href: "/hizmetler/".concat(slug[locale]),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_BImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        className: "rounded-md",
                        src: imageUrl || "",
                        layout: "responsive",
                        width: 281,
                        height: 434,
                        alt: "name",
                        priority: prioritizeImg
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-medium mt-1 text-base md:text-lg",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-1 text-sm text-slate-500 md:text-base",
                        children: description
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OrganizationCard);


/***/ }),

/***/ 15010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Seo_SeoWrapper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85157);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(28525);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(44926);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/script.js
var next_script = __webpack_require__(67320);
var script_default = /*#__PURE__*/__webpack_require__.n(next_script);
// EXTERNAL MODULE: ./node_modules/react-helmet/es/Helmet.js
var Helmet = __webpack_require__(40686);
;// CONCATENATED MODULE: ./src/components/Seo/SeoContent.tsx

var SeoContent = function(param) {
    var content = param.content;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "seo-content prose prose-slate relative mx-auto w-full max-w-none",
            dangerouslySetInnerHTML: {
                __html: content
            }
        })
    });
};
/* harmony default export */ var Seo_SeoContent = (SeoContent);

;// CONCATENATED MODULE: ./src/components/Seo/SeoWrapper.tsx







var SeoWrapper = function(param) {
    var children = param.children, helmetSettings = param.helmetSettings, content = param.content;
    var title = helmetSettings.title, script = helmetSettings.script, restHelmetSettings = (0,_object_without_properties/* default */.Z)(helmetSettings, [
        "title",
        "script"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Helmet/* Helmet */.q, (0,_object_spread/* default */.Z)({}, restHelmetSettings)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: title
                })
            }),
            script ? /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "schema",
                type: "application/ld+json",
                strategy: "beforeInteractive",
                dangerouslySetInnerHTML: {
                    __html: script
                }
            }) : null,
            children,
            content ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Seo_SeoContent, {
                content: content
            }) : null
        ]
    });
};
/* harmony default export */ var Seo_SeoWrapper = (SeoWrapper);


/***/ }),

/***/ 73351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32852);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88082);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32466);
/* harmony import */ var _TranslatedLink__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31468);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67320);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var hooks_useLocale__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74021);







var BBreadcrumb = function(param) {
    var breadcrumbItems = param.breadcrumbItems, wrapperClasses = param.wrapperClasses;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().t;
    var locale = (0,hooks_useLocale__WEBPACK_IMPORTED_MODULE_6__/* .useLocale */ .b)().locale;
    var isCurrent = function(idx) {
        return idx === breadcrumbItems.length - 1;
    };
    var breadcrumbSchema = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return '{"@context": "https://schema.org","@type": "BreadcrumbList","itemListElement": ['.concat(breadcrumbItems.map(function(item, idx) {
            var label = item.isTranslatable ? t(item.label) : item.label;
            var nonQPLink = item.link.split("?")[0];
            var prefixedLink = "https://www.teknevia.com".concat(nonQPLink);
            return '{"@type": "ListItem","position":'.concat(+idx + 1, ',"name":"').concat(label, '","item":"').concat(prefixedLink, '"}');
        }).join(","), "]}");
    }, [
        breadcrumbItems,
        t,
        locale
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
        "aria-label": "breadcrumbs",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_5___default()), {
                id: "breadcrumb-schema",
                type: "application/ld+json",
                strategy: "beforeInteractive",
                dangerouslySetInnerHTML: {
                    __html: breadcrumbSchema
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(wrapperClasses, "flex flex-wrap items-center gap-2"),
                children: breadcrumbItems.map(function(item, idx) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("breadcrumb-item text-xs md:text-sm", {
                            "text-primary-600 underline": !isCurrent(idx),
                            "text-black": isCurrent(idx)
                        }),
                        children: isCurrent(idx) ? item.isTranslatable ? t(item.label) : item.label : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TranslatedLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            href: item.link,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: item.isTranslatable ? t(item.label) : item.label
                            })
                        })
                    }, item.link);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BBreadcrumb);


/***/ }),

/***/ 11455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36840);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32852);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32466);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48063);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10520);








var ResponsiveCarousel = function(param) {
    var className = param.className, children = param.children, _pagination = param.pagination, pagination = _pagination === void 0 ? false : _pagination, _slidesPerView = param.slidesPerView, slidesPerView = _slidesPerView === void 0 ? "auto" : _slidesPerView, _spaceBetween = param.spaceBetween, spaceBetween = _spaceBetween === void 0 ? undefined : _spaceBetween, _spacing = param.spacing, spacing = _spacing === void 0 ? "px-2" : _spacing, onSlideChange = param.onSlideChange;
    var modules = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(pagination ? [
        swiper__WEBPACK_IMPORTED_MODULE_3__/* .Pagination */ .tl
    ] : []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("responsive-carousel w-full", className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .Swiper */ .tq, {
            modules: modules,
            pagination: pagination ? {
                clickable: true,
                dynamicBullets: true,
                dynamicMainBullets: 5
            } : false,
            spaceBetween: spaceBetween,
            slidesPerView: slidesPerView,
            onSlideChange: onSlideChange,
            children: react__WEBPACK_IMPORTED_MODULE_2__.Children.map(children, function(child) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o5, {
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("mx-auto first:pl-0 last:pr-0", spacing),
                    children: child
                });
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ResponsiveCarousel);


/***/ }),

/***/ 54865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ useBreadcrumbs; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36840);
/* harmony import */ var utils_slugify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27576);
/* harmony import */ var _useLocale__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74021);
/* harmony import */ var services_LinkService__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41824);
/* harmony import */ var utils_getLocalePrefix__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14211);





function useBreadcrumbs() {
    var locale = (0,_useLocale__WEBPACK_IMPORTED_MODULE_1__/* .useLocale */ .b)().locale;
    var baseBreadcrumbItem = {
        label: "Teknevia",
        link: "/",
        isTranslatable: false
    };
    var defaultBreadcrumbs = [
        baseBreadcrumbItem
    ];
    var generateCategoryLinks = function(category, location) {
        var generatedBreadcrumbsArray = [
            {
                label: category.label,
                link: (0,utils_getLocalePrefix__WEBPACK_IMPORTED_MODULE_3__/* .getLocalePrefix */ .A)(locale) + category.value,
                isTranslatable: false
            }, 
        ];
        if (location) {
            var _loop = function(idx) {
                var labelKey = labelKeys[idx];
                var slugKey = slugKeys[idx];
                var locationLabel = location[labelKey] + " " + category.label;
                var _slugKey;
                var locationSlug = services_LinkService__WEBPACK_IMPORTED_MODULE_2__/* .linkService.generateCategoryLink */ .k.generateCategoryLink({
                    locale: locale,
                    locationSlug: (_slugKey = location[slugKey]) !== null && _slugKey !== void 0 ? _slugKey : (0,utils_slugify__WEBPACK_IMPORTED_MODULE_0__/* .slugifyText */ .E)("".concat(locationLabel)),
                    category: category.value
                });
                var hasAnySameLabel = generatedBreadcrumbsArray.some(function(item) {
                    return item.label === locationLabel;
                });
                if (!hasAnySameLabel) {
                    generatedBreadcrumbsArray.push({
                        label: locationLabel,
                        link: locationSlug,
                        isTranslatable: false
                    });
                }
                if (labelKey.includes(matchType)) {
                    return "break";
                }
            };
            var labelKeys = [
                "cityName",
                "regionName",
                "harborName"
            ];
            var slugKeys = [
                "citySlug",
                "regionSlug",
                "harborSlug"
            ];
            var matchType = location.matchType;
            for(var idx in labelKeys){
                var _ret = _loop(idx);
                if (_ret === "break") break;
            }
        }
        return generatedBreadcrumbsArray;
    };
    var generateOrganizationBreadcrumbs = function(subPage) {
        return [
            baseBreadcrumbItem,
            {
                label: "organizations:home.title",
                link: "/hizmetler",
                isTranslatable: true
            }, 
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(subPage ? [
            subPage
        ] : []));
    };
    return {
        defaultBreadcrumbs: defaultBreadcrumbs,
        onlyTekneViaBreadcrumb: defaultBreadcrumbs[0],
        generateCategoryLinks: generateCategoryLinks,
        generateOrganizationBreadcrumbs: generateOrganizationBreadcrumbs
    };
}


/***/ }),

/***/ 63579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ hizmetler; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85157);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18098);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/components/common/ResponsiveCarousel.tsx
var ResponsiveCarousel = __webpack_require__(11455);
// EXTERNAL MODULE: ./src/components/Organizations/OrganizationCard.tsx
var OrganizationCard = __webpack_require__(58091);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(32852);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/components/Organizations/OrganizationPageSectionTitle.tsx


var OrganizationPageSectionTitle = function(param) {
    var title = param.title, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
        className: classnames_default()("text-semibold block w-max text-xl", className),
        children: title
    });
};
/* harmony default export */ var Organizations_OrganizationPageSectionTitle = (OrganizationPageSectionTitle);

;// CONCATENATED MODULE: ./src/components/Organizations/OrganizationPageCategorySection.tsx







var OrganizationPageCategortSection = function(param) {
    var title = param.title, organizations = param.organizations, keyName = param.keyName, wrapperClass = param.wrapperClass, _prioritizeImg = param.prioritizeImg, prioritizeImg = _prioritizeImg === void 0 ? false : _prioritizeImg, _isCarousel = param.isCarousel, isCarousel = _isCarousel === void 0 ? false : _isCarousel;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: wrapperClass,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Organizations_OrganizationPageSectionTitle, {
                title: title,
                className: "mb-6"
            }),
            isCarousel ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveCarousel/* default */.Z, {
                spacing: "px-1 md:px-3",
                children: organizations.map(function(org) {
                    return /*#__PURE__*/ (0,react.createElement)(OrganizationCard/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        prioritizeImg: prioritizeImg
                    }, org), {
                        key: "".concat(keyName, "-").concat(org.id)
                    }));
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-2 justify-items-center gap-4 md:gap-6 lg:grid-cols-3 xl:grid-cols-4",
                children: organizations.map(function(org) {
                    return /*#__PURE__*/ (0,react.createElement)(OrganizationCard/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        prioritizeImg: prioritizeImg
                    }, org), {
                        key: "".concat(keyName, "-").concat(org.id)
                    }));
                })
            })
        ]
    });
};
/* harmony default export */ var OrganizationPageCategorySection = (OrganizationPageCategortSection);

// EXTERNAL MODULE: ./src/components/Seo/SeoWrapper.tsx + 1 modules
var SeoWrapper = __webpack_require__(15010);
// EXTERNAL MODULE: ./src/components/common/BBreadcrumb.tsx
var BBreadcrumb = __webpack_require__(73351);
// EXTERNAL MODULE: ./src/hooks/useBreadcrumbs.ts
var useBreadcrumbs = __webpack_require__(54865);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(88082);
;// CONCATENATED MODULE: ./src/pages/hizmetler/index.tsx






var Organizations = function(param) {
    var organizationsByCategory = param.organizationsByCategory, content = param.content, helmetSettings = param.helmetSettings;
    var t = (0,useTranslation/* default */.Z)("organizations").t;
    var generateOrganizationBreadcrumbs = (0,useBreadcrumbs/* useBreadcrumbs */.h)().generateOrganizationBreadcrumbs;
    var breadcrumbs = generateOrganizationBreadcrumbs();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SeoWrapper/* default */.Z, {
        content: content,
        helmetSettings: helmetSettings,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BBreadcrumb/* default */.Z, {
                breadcrumbItems: breadcrumbs,
                wrapperClasses: "mb-4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-semibold mb-6 text-2xl",
                children: t("home.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrganizationPageCategorySection, {
                title: t("home.popularOrganizations.title"),
                organizations: organizationsByCategory.POPULAR,
                isCarousel: true,
                keyName: "populer-organizations",
                wrapperClass: "mb-12",
                prioritizeImg: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrganizationPageCategorySection, {
                title: t("home.corporateOrganizations.title"),
                organizations: organizationsByCategory.BUSINESS,
                isCarousel: true,
                keyName: "corporate-organizations",
                wrapperClass: "mb-12"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrganizationPageCategorySection, {
                title: t("home.otherOrganizations.title"),
                organizations: organizationsByCategory.OTHER,
                keyName: "other-organizations"
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var hizmetler = (Organizations);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3457,5867,9774,2888,179], function() { return __webpack_exec__(83518); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);